import { Link, Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import ForbiddenImageSrc from './forbidden.png'
import config from 'config'

const Root = styled('div')(({ theme }) => ({
    backgroundColor: ' #eef0f4',
    textAlign: 'center',
    '& img': {
        marginTop: '6vw',
        margin: 'auto',
        maxWidth: '50%',
    },
}))

const Content = styled(Box)(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        marginTop: '-15%',
    },
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    flexWrap: 'wrap',
    textAlign: 'center',
    background: 'transparent',
    left: 0,
    right: 0,
}))

const Footer = styled(Box)(({ theme }) => ({
    maxWidth: 625,
    marginTop: '-4.5rem',
    margin: 'auto',
    left: 0,
    right: 0,
    marginBottom: '7rem',
}))

const Container = styled(Box)(({ theme }) => ({
    marginTop: '-6.5rem',
    [theme.breakpoints.down('xl')]: {},
}))

const ForbiddenText = styled(Typography)(({ theme }) => ({
    color: ' #3f3767',
    fontWeight: '300',
    fontSize: '14vw',
}))

const StyledTypography = styled(Typography)(({ theme }) => ({
    fontSize: '3rem',
    [theme.breakpoints.down('lg')]: {
        fontSize: '2.2rem',
        paddingLeft: '2rem',
    },
    [theme.breakpoints.up('lg')]: {
        fontSize: '2.25vw',
        paddingLeft: '3.2rem',
    },
}))

const ForbiddenPage = (props) => {
    const { description, linkText, errorCode, showLink = true } = props

    return (
        <>
            <Root>
                <img
                    src={`${config.APP_SUBPATH}${ForbiddenImageSrc}`}
                    alt="Forbidden Page"
                />

                <Content>
                    <Container>
                        <ForbiddenText>{errorCode}</ForbiddenText>
                    </Container>
                </Content>
                <Footer>
                    <Box>
                        <Box>
                            <Typography sx={{ fontSize: '2.2rem' }}>
                                {description}
                                {showLink && (
                                    <Link
                                        component="a"
                                        underline="none"
                                        href={`${config.APP_SUBPATH}/`}
                                        sx={{
                                            color: '#453fbb',
                                            fontSize: '2.2rem',
                                            fontWeight: 300,
                                            marginLeft: '0.8rem',
                                        }}
                                    >
                                        {linkText}
                                    </Link>
                                )}
                            </Typography>
                        </Box>
                    </Box>
                </Footer>
            </Root>
        </>
    )
}

export default ForbiddenPage
